import React from "react"
import { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap"
import {connect} from "react-redux";
import { withUAL } from 'ual-reactjs-renderer'
import { OreId, AuthProvider} from "oreid-js";
import { WebPopup } from "oreid-webpopup";
import { OreidProvider, useIsLoggedIn, useOreId } from "oreid-react";
import LoginButton from 'oreid-login-button';
import {oreLogin}  from '@store/actions/auth/loginActions';

const loginButtonStyle = { width: 200, marginTop: '24px', cursor: 'pointer' };
  var userData;
  var isLoggedIn = false;
  const oreIdOptions = {
    appName: "oreid",
    appId: process.env.REACT_APP_OREID_APP_ID,
    plugins: { popup: WebPopup() }
  }
  var oreId = new OreId(oreIdOptions);
  oreId.init()
  const AppWithProvider = (props) => {
    isLoggedIn = useIsLoggedIn()
    return (
      <div>
        {isLoggedIn ?  props.closeModal.closeModal() : <LoginPage onSuccessHandler={props.onSuccessHandler}/>}
      </div>
    )
  };
  export const App = (props) => {
    const [oreidReady, setOreidReady] = useState(false);
    useEffect(() => {
        oreId.init()
            .then(() => {
                setOreidReady(true);
            })
            .catch((error) => console.log(error));
    }, []);

    if (!oreidReady) {
        return true;
    }

    return (
      <OreidProvider oreId={ oreId }>
      <AppWithProvider closeModal={props} onSuccessHandler={props.onSuccessHandler}/>
      </OreidProvider>
    );
  };
    
     const LoginPage = (props) => {
      const oreId = useOreId();
      const [error, setError] = useState("");
  
      const onError = (error) => {
          setError(error);
      };
  
      const onSuccess = ({ user }) => {
          console.log("Login successfull. User Data: ", user);
          props.onSuccessHandler(user);
      };
      
      const loginWithProvider = (provider) => {
          oreId.popup
              .auth({
                  provider,
              })
              .then( onSuccess )
              .catch( onError );
      }
       return (

         <div>
           <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px' }}>
             <LoginButton
               provider="apple"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.Apple)}
             />
             <LoginButton
               provider="google"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.Google)}
             />
             <LoginButton
               provider="twitter"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.Twitter)}
             />
             <LoginButton
               provider="linkedin"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.LinkedIn)}
             />
             <LoginButton
               provider="twitch"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.Twitch)}
             />
             <LoginButton
               provider="facebook"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.Facebook)}
             />
           </div>
           <div className="modal_header" style={{ paddingTop: '13px' }}>
             <LoginButton 
               provider="instagram"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.Instagram)}
             />
             </div>
           <p>&nbsp;</p>
           <span className="modal_header " style={{ color: 'black', marginTop: '10px'}}>Login with Email or SMS</span>
           <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', paddingBottom: '25px' }}>
             
             <LoginButton
               provider="email"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.Email)}
             />
             <LoginButton
               provider="phone"
               buttonStyle={loginButtonStyle}
               onClick={() => loginWithProvider(AuthProvider.Phone)}
             />
           </div>
         </div>
       );
  }
class LoginModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            app: false,
            viewOreId: false
        }
    }
    componentDidMount = async () => {
      if(oreId.auth.user._accountName){
        userData =  await oreId.auth.user?.getData()
      }
    }
    componentDidUpdate = async(prevProps, prevState) => {
      if(oreId.auth.user._accountName){
        userData =  await oreId.auth.user?.getData()
      }else {
        if(userData){
          let pubKeys = [userData?.chainAccounts[0].defaultPermission.publicKey, userData?.chainAccounts[1].defaultPermission.publicKey, userData?.chainAccounts[1].permissions[0].publicKey];
          let userAccount = userData?.accountName;
          this.props.oreLogin( pubKeys, userAccount, ()=>{
              this.setState({showSelectLogin:false})
          });
        } 
      }
       
    }
    onSuccessHandler = function(userData) {
      if (userData) {
        let pubKeys = [userData?.chainAccounts[0].defaultPermission.publicKey, userData?.chainAccounts[1].defaultPermission.publicKey, userData?.chainAccounts[1].permissions[0].publicKey];
        let userAccount = userData?.accountName;
        this.props.oreLogin( pubKeys, userAccount, ()=>{
            this.setState({showSelectLogin:false})
        });
      }
    }
    render() {
      return (
        <React.Fragment >
          <Modal
            size="md"
            isOpen={true}
            className="modal-dialog modal-dialog-centered login-modal" >
              <ModalHeader toggle={this.props.closeModal} style={{justifyContent:'right', background:'transparent'}}> </ModalHeader>
              <ModalBody>
                <p className="modal_header" style={{color:'black', marginBottom:'10px'}}>Login with WAX wallet</p>
                <div className='btn btn-outline-primary d-flex justify-content-center rounded-sm' 
                  style={{backgroundColor:'#3650A2', marginBottom:'10px', marginLeft:'27px', marginRight:'27px'}} 
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.ual.showModal();
                    this.props.closeModal()
                  }}>LOGIN
                </div>
                <p>&nbsp;</p>   
                <span className="modal_header" style={{color:'black'}}>{this.state.viewOreId ? "Login with a Social Account" : "Login with OreId(deprecated end of 2023)"}</span>
                {!this.state.viewOreId &&  <div className='btn btn-outline-primary d-flex justify-content-center rounded-sm' 
                                                style={{backgroundColor:'#3650A2', marginBottom:'10px', marginLeft:'27px', marginRight:'27px',marginTop:'10px',}} 
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                this.setState({viewOreId:true})
                                              }}> Login With OreId
                                           </div>}
                {this.state.viewOreId && <App closeModal={()=>{this.props.closeModal()}} onSuccessHandler={(userData)=>{this.onSuccessHandler(userData)}} /> }
              </ModalBody>
          </Modal>
        </React.Fragment>
      )
    }
}

const mapStateToProps = state => {
  return {
    user: state.authorizedUser.user,
    wax: state.authorizedUser.wax,
    socket_user: state.socket.socket_user,
    socket_connected: state.socket.socket_connected,
    got_nft_list:state.nft.got_nft_list
  }
}

export default withUAL(connect(mapStateToProps, {oreLogin})(LoginModal))

